import { DataDocument, tagsTemplateDirectoryId } from '@fillip/api';

export const TemplateTagMarkdown: DataDocument = {
  id: 'tag-markdown',
  parentId: tagsTemplateDirectoryId,
  info: {
    title: 'Markdown',
    icon: 'hashtag',
    isProtected: true,
  },
  element: {
    type: 'element.markdown',
    markdownContent: ':$text',
  },
  class: {
    class: ':`${$containerClasses}`',
    elementClass: ':`${$elementClasses}`',
  },
  tag: {
    tag: 'tag',
  },
  tagDefinition: {
    tag: 'markdown',
    title: 'Markdown',
    category: 'content',
    icon: 'hashtag',
    editor: 'markdown',
  },
  interfaceDefinition: {
    title: '',
    inheritFrom: 'baseContent',
    props: [
      {
        title: 'Container Classes',
        key: 'containerClasses',
        type: 'string',
        defaultValue:
          ":`${$$contentTagClasses} ${$$textClasses} ${$containerClasses || properties?.containerClasses?.value || ''}`",
      },
      {
        title: 'Element Classes',
        key: 'elementClasses',
        type: 'string',
        defaultValue:
          ":`${$elementClasses || properties?.elementClasses?.value || ''}`",
      },
    ],
  },
};
